import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0a0a0f',
          color: '#d0d0e0',
          padding: '40px 20px',
          textAlign: 'center',
          fontFamily: "Cinzel, Georgia, serif",
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>✦</div>
          <h1 style={{
            fontSize: '24px',
            color: '#c9a84c',
            fontWeight: 600,
            margin: '0 0 12px',
          }}>
            Something went wrong
          </h1>
          <p style={{
            fontSize: '15px',
            color: 'rgba(208,208,224,0.6)',
            maxWidth: '360px',
            lineHeight: 1.6,
            margin: '0 0 32px',
            fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          }}>
            The cosmos hiccupped. Tap below to return home.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '12px 32px',
              fontSize: '15px',
              fontWeight: 600,
              color: '#0a0a0f',
              background: 'linear-gradient(135deg, #c9a84c, #e8d48b)',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
              transition: 'transform 0.2s',
            }}
            onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.03)')}
            onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
          >
            Return to Today
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
